import func from "@uikit/func";

export default function loadAvailableImg(images, imgKey) {
  return new Promise(resolve => {
    if (func.isEmpty(images)) {
      resolve({
        loading: false,
        value: "", // todo:这里应该是一张占位图
      });
      return;
    }
    const img = new Image();
    let imgIdx = 0;
    img.onload = () => {
      resolve({
        loading: false,
        value: img.src,
      });
    };
    img.onerror = () => {
      if (imgIdx >= images.length) {
        resolve({
          loading: false,
          value: "", // todo:这里应该是一张占位图
        });
        return;
      }
      imgIdx++;
      img.src = images[imgIdx]?.[imgKey] || "";
    };
    img.src = images[imgIdx]?.[imgKey] || "";
  });
}
